var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#3063d5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.305 3.893)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(-7.305 -3.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.105,6.25A15.857,15.857,0,1,0,37.964,22.108,15.869,15.869,0,0,0,22.105,6.25Zm0,1.511A14.346,14.346,0,1,1,7.761,22.108,14.336,14.336,0,0,1,22.105,7.761Z",
    transform: "translate(-6.555 -6.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.42,14.582A12.836,12.836,0,1,0,40.257,27.419,12.847,12.847,0,0,0,27.42,14.582Zm0,1.511A11.326,11.326,0,1,1,16.094,27.419,11.314,11.314,0,0,1,27.42,16.093Z",
    transform: "translate(-11.565 -11.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.657,22.887a.755.755,0,0,0-.743.765v9.064h0a.749.749,0,0,0,.222.532l4.529,4.533a.756.756,0,1,0,1.07-1.068L49.425,32.4v-8.75a.754.754,0,0,0-.767-.763Z",
    transform: "translate(-32.813 -16.857)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.bcb05504d0393fd7a463c30eab6941ab.svg";
export { ForwardRef as ReactComponent };